












import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseIcon from '@lib-ui/components/base-icon/_base-icon.vue';

@Component({
  name: 'BaseSearchBox',
  components: {
    BaseIcon,
  },
})
export default class BaseSearchBox extends Vue {
  @Prop({ default: false }) doFocus?: boolean;

  get listeners(): Record<string, Function | Function> {
    return { ...this.$listeners, input: event => this.$emit('input', event.target.value) };
  }

  setFocus() {
    const element: HTMLElement = this.$refs.searchBox as HTMLElement;
    element.focus();
  }

  mounted() {
    if (this.doFocus) {
      this.setFocus();
    }
  }
}
